"use client"

import { NativeSelect as Select, useSlotRecipe } from "@chakra-ui/react"
import * as React from "react"
import select from "./styling/select"

interface NativeSelectRootProps extends Select.RootProps {
  icon?: React.ReactNode
  active?: boolean
}

export const NativeSelectRoot = React.forwardRef<HTMLDivElement, NativeSelectRootProps>(function NativeSelect(
  props,
  ref
) {
  const { icon, children, active, ...rest } = props
  const recipe = useSlotRecipe({ recipe: select })
  const styles = recipe({ variant: "hydrologiq" })
  return (
    <Select.Root ref={ref} css={styles.root} {...rest} className={active ? "active" : ""}>
      {children}
      <Select.Indicator css={styles.indicator}>{icon}</Select.Indicator>
    </Select.Root>
  )
})

export interface NativeSelectItem {
  value: string
  label: string
  disabled?: boolean
}

interface NativeSelectField extends Select.FieldProps {
  items?: Array<string | NativeSelectItem>
}

export const NativeSelectField = React.forwardRef<HTMLSelectElement, NativeSelectField>(function NativeSelectField(
  props,
  ref
) {
  const { items: itemsProp, children, ...rest } = props
  const recipe = useSlotRecipe({ recipe: select })
  const styles = recipe({ variant: "hydrologiq" })
  const items = React.useMemo(
    () => itemsProp?.map((item) => (typeof item === "string" ? { label: item, value: item } : item)),
    [itemsProp]
  )

  return (
    <Select.Field ref={ref} {...rest} css={styles.control}>
      {children}
      {items?.map((item) => (
        <option key={item.value} value={item.value} disabled={item.disabled}>
          {item.label}
        </option>
      ))}
    </Select.Field>
  )
})
